import React from 'react';
import { ImageCropTool } from './crop';

const Toolbar = ({ element, viewport }) => {
  return <ImageCropTool element={element} scale={viewport.scale} />;
};

export const wrapImageOverlayer = (Overlayer) => (props) => {
  const { currentElementTool, editingElementId, element } = props;
  const isActive = currentElementTool === 'crop' && editingElementId === element.id;
  const toolbar = isActive ? <Toolbar {...props} /> : props.toolbar;
  const innerClassName = '';
  const outerClassName = isActive ? 'w-full h-full absolute !top-0' : '';
  return <Overlayer {...props} toolbar={toolbar} innerClassName={innerClassName} outerClassName={outerClassName} />;
};
